/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable max-statements */
import { useState, useEffect, useContext, useRef } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import useGoogleLogin from './useGoogleLogin';
import API from '../lib/API';
import useFacebookLogin from './useFacebookLogin';
import useAppleLogin from '@hooks/useAppleLogin';
import {
  closeAuthModal,
  closeQuestionModal,
  openQuestionModal,
  openTeamSelectionModal,
  openPersonaModal,
  openTeamInviteModal,
} from '../store/actions';
import { DispatchContext, StateContext } from '../store/store';
import { checkParameters } from '@utils/auth/checkParams';
import useForm from './useForm/useForm';
import useDeviceDetect from '@hooks/useDeviceDetect';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { getCookieValue, setCookie } from '@utils/cookie';
import { loadScript } from '@utils/loadScript';
import jwt_decode from 'jwt-decode';

import { pageType, removeParams } from '@utils/amplitude.utils';
import { getEditorHost, updateEditorAuthCookie } from '@utils/editor';

function useAuth(options = { isPhoneRequired: true }) {
  const affliateLink = false;
  const payments = false;
  const payments_url = '';
  const type = '';
  const exit_url = false;
  let new_user_templates = false;
  const AuthAPI = new API();
  let goToTemplates = false;
  const dispatch = useContext(DispatchContext);
  const globalStore = useContext(StateContext);
  const { t } = useTranslation();
  const { deviceType } = useDeviceDetect();

  const [authState, setAuthState] = useState({
    keyword: '',
    matchtype: '',
    creative: '',
    placement: '',
    device: '',
    site_source_name: '',
    campaign_id: '',
    adset_id: '',
    ad_id: '',
    adset_name: '',
    ad_name: '',
    campaign_name: '',
  });
  const [isMeetupPresent, setIsMeetupPresent] = useState(false);
  const [domain, setDomain] = useState('');
  const [category, setCategory] = useState('');
  const [tool_redirect_url, setTool_redirect_url] = useState('');
  const [userObject, setUserObject] = useState({});
  const [socialLoginRequestPayload, setSocialLoginRequestPayload] = useState();

  const [loginFormError, setLoginFormError] = useState();
  const [signupError, setSignupError] = useState();
  const [guestSignupError, setGuestSignupError] = useState();
  const [forgotFormError, setForgotFormError] = useState();

  const [countryCodes, setCountryCodes] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('IN');

  const [forgotPasswordSuccess, setForgotPasswordSuccess] = useState(false);
  const [isGuestSignupSubmitting, setIsGuestSignupSubmitting] = useState(false);

  const { executeRecaptcha } = useGoogleReCaptcha();

  const oAuthWindow = useRef(null);
  let stopOauthTimer;

  useEffect(() => {
    fetch('/landing-web-static/constants/countrycodes.json')
      .then(data => data.json())
      .then(res => {
        setCountryCodes(res);

        fetch('https://pro.ip-api.com/json?key=u04vUx7J6T6ey8h')
          .then(response => response.json())
          .then(data => {
            const country = res.filter(c => c.code === data.countryCode);

            if (country[0]) {
              setSelectedCountry(country[0].code);
            }
          })
          .catch(error => {
            console.error(error);
          });
      });
  }, []);

  function getCountry(cc) {
    const current_country = countryCodes.findIndex(p => p.code === cc);
    if (current_country !== -1) {
      return countryCodes[current_country];
    }
    return false;
  }

  const handleOnChangeCountry = e => {
    if (e.target.value) {
      setSelectedCountry(e.target.value);
    }
  };

  const {
    onChange: onLoginChange,
    onBlur: onLoginBlur,
    isValid: isLoginValid,
    isSubmitting: isLoginSubmitting,
    errors: loginErrors,
    values: loginValues,
    resetErrors: resetLoginErrors,
    handleSubmit: handleLoginSubmit,
    setErrorField: setLoginErrorField,
  } = useForm({
    defaultValues: {
      emailLogin: '',
      passwordLogin: '',
    },
    validations: {
      emailLogin: {
        Validator: 'Email',
        required: true,
        requiredMessage: 'Email is required',
        errorMessage: t('authModal.EnterAValidEmail'),
      },
      passwordLogin: {
        pattern: /^.{6,50}$/gi,
        required: true,
        requiredMessage: 'Password is required',
        errorMessage: t('authModal.MinSixChar'),
      },
    },
    onSubmit: async (values, { setIsSubmitting }) => {
      const data = {
        userid: values.emailLogin,
        password: values.passwordLogin,
        route: 'invideo',
        page_source: window.location.href,
        device_id: window.deviceId || '',
      };

      checkParameters(data, domain);

      const result = await executeRecaptcha();
      data['recaptcha_response'] = result;

      return AuthAPI.emailLogin(data)
        .then(({ data: authResponse }) => {
          if (authResponse && authResponse['jwt_token']) {
            // this.postGoogleLoginHandler(data.response, data.data);

            localStorage.setItem('authToken', authResponse['jwt_token']);
            AuthAPI.getCompleteUserDetails()
              .then(res => {
                if (res.data) {
                  localStorage.setItem('authToken', authResponse['jwt_token']);
                  return res.data;
                } else {
                  setLoginFormError('Failed to fetch the data');
                }
              })
              .then(response => {
                if (typeof response === 'object') {
                  setUserObject({
                    identity: values.emailLoginemail,
                    secret: values.passwordLogin,
                  });
                  setCookieData(response);
                  analyticaDeInVideoV2(response, 'Email').then(() => {
                    if (
                      deviceType === 'desktop' &&
                      pageType() === 'Make Page'
                    ) {
                      const isHeaderCtaClicked =
                        sessionStorage.getItem('isHeaderCTAClicked');

                      if (isHeaderCtaClicked) {
                        redirectUserToTool(response);
                      } else {
                        dispatch(openQuestionModal({ tab: 'signup' }));
                        dispatch(closeAuthModal());
                      }
                    } else {
                      redirectUserToTool(response);
                    }
                  });
                  setSocialLoginRequestPayload(response);
                }
                setIsSubmitting(false);
              });
          }
        })
        .catch(error => {
          if (error.response.status === 403) {
            setLoginFormError(t('authModal.InvalidUserNamePassword'));
          }
          setIsSubmitting(false);
        });
    },
  });

  const {
    errors: signupErrors,
    handleSubmit: handleSingup,
    onBlur: onBlurSignup,
    isSubmitting: isSignupSumitting,
    onChange: onChangeSignup,
    values: signupValues,
    isValid: isValidSignup,
  } = useForm({
    defaultValues: {
      full_name: '',
      emailSignup: '',
      passwordSignup: '',
      phoneNumber: '',
    },
    validations: {
      full_name: {
        pattern: /\w/gi,
        required: true,
        requiredMessage: 'Full Name is required',
        errorMessage: 'Name is Required',
      },
      emailSignup: {
        Validator: 'Email',
        required: true,
        requiredMessage: 'Email is required',
        errorMessage: t('authModal.EnterAValidEmail'),
      },
      passwordSignup: {
        pattern: /^.{6,50}$/gi,
        required: true,
        requiredMessage: 'Password is required',
        errorMessage: t('authModal.MinSixChar'),
      },
      phoneNumber: {
        pattern: /\d{8,}/gi,
        required: options.isPhoneRequired,
        requiredMessage: 'Phone Number is required',
        errorMessage: 'Enter a valid Phone number',
      },
    },
    onSubmit: async (values, { setIsSubmitting }) => {
      const full_name = values.full_name;
      const email = values.emailSignup;
      const password = values.passwordSignup;

      const currentCountry = getCountry(selectedCountry);

      const phone = `${currentCountry.value} ${values.phoneNumber}`;
      const country = currentCountry.name.split(' (')[0];

      const data = {
        full_name,
        email,
        password,
        route: 'invideo',
        referrer: 'website',
        phone,
        country,
        page_source: window.location.href,
        device_id: window.deviceId || '',
      };
      if (isMeetupPresent) {
        data.type = 'meetup';
      }

      // Adding Recaptcha
      const result = await executeRecaptcha();
      data['recaptcha_response'] = result;

      checkParameters(data, domain);

      data['joined_via'] = 'self';
      data['invited_from'] = 'self';

      return AuthAPI.emailSignup(data)
        .then(({ data: authResponse }) => {
          if (authResponse && authResponse['jwt_token']) {
            // this.postGoogleLoginHandler(data.response, data.data);

            localStorage.setItem('authToken', authResponse['jwt_token']);
            AuthAPI.getCompleteUserDetails()
              .then(res => {
                if (res.data) {
                  localStorage.setItem('authToken', authResponse['jwt_token']);
                  return res.data;
                } else {
                  setSignupError('Failed to fetch the data');
                }
              })
              .then(response => {
                if (typeof response === 'object') {
                  setCookieData(response);
                  analyticaDeInVideoV2(response, 'Email').then(() => {
                    dispatch(openPersonaModal());
                    dispatch(closeAuthModal());
                    return;
                    if (deviceType === 'mobile' || deviceType === 'tablet') {
                      AuthAPI.fetchInviteData(response.token)
                        .then(inviteDataResponse => {
                          if (
                            !!inviteDataResponse?.data?.data?.status &&
                            window.location.pathname === '/'
                          ) {
                            dispatch(closeAuthModal());
                            dispatch(
                              openTeamSelectionModal({
                                team: inviteDataResponse.data.data.name,
                                inviter: inviteDataResponse.data.data.inviter,
                              }),
                            );
                          } else {
                            redirectUserToTool(response);
                            dispatch(closeAuthModal());
                          }
                        })
                        .catch(error => {
                          console.error(error);
                        });
                      redirectUserToTool(response);
                    }
                    if (deviceType === 'desktop') {
                      dispatch(openPersonaModal());
                      dispatch(closeAuthModal());
                    }
                  });
                } else {
                  setSignupError('An account already exists with this Email');
                }
                return response;
              });
          }
        })

        .catch(error => {
          if (error.response.status === 403) {
            setSignupError(
              error.response.data.message ||
                'An account already exists with this Email',
            );
          }
          if (error.response.status === 400) {
            setSignupError(
              error.response.data.message || 'Enter a valid Email address',
            );
          }
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    },
  });

  const {
    errors: errorsForgotPassword,
    handleSubmit: handleSubmitForgotPassword,
    isSubmitting: isSubmittingForgot,
    onChange: onChangeForgotPassword,
    values: valuesForgotPassowrd,
    isValid: isValidForgotPassword,
    onBlur: onBlurForgotPassword,
  } = useForm({
    defaultValues: {
      emailForgot: '',
    },
    validations: {
      emailForgot: {
        Validator: 'Email',
        required: true,
        requiredMessage: 'Email is required',
        errorMessage: t('authModal.EnterAValidEmail'),
      },
    },
    onSubmit: async (values, { setIsSubmitting }) => {
      const link = window.location.origin;
      const email = values.emailForgot;

      const token = await executeRecaptcha();

      AuthAPI.forgotPassword({
        email,
        shy: window.btoa(email),
        link,
        config: 'invideo',
        recaptcha_response: token,
      })
        .then(() => {
          setForgotPasswordSuccess(true);
        })
        .catch(error => {
          if (error.response.status === 403) {
            setForgotFormError('Something Went Wrong, Please try again');
          }
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    },
  });

  const { signIn: googleSignIn, getGoogleProfileInfo } = useGoogleLogin({
    onSuccess(res) {
      getGoogleProfileInfo().then(profileData => {
        const fullName = profileData.name;
        const id = profileData.sub;
        const password = profileData.sub;
        const email = profileData.email;
        const image = '';
        const route = 'google';
        const data = {
          full_name: fullName,
          image,
          email,
          password,
          uid: id,
          brand_name: 'Your Company Name',
          route: 'google',
          referrer: 'website',
          page_source: window.location.href,
          device_id: window.deviceId || '',
        };
        if (isMeetupPresent) {
          data.type = 'meetup';
        }

        checkParameters(data, domain);
        setSocialLoginRequestPayload(data);
        // $('#userName').html(fullName);
        sendGoogleLoginDataToBackend(data);
      });
    },
    onFailure(error) {
      // setError(prevState => ({
      //   ...prevState,
      //   socialEmail: 'An account already exists with this Email',
      // }));
      console.error(error);
    },
  });

  const { facebookLogin } = useFacebookLogin({
    onSuccess(data) {
      if (isMeetupPresent != -1) {
        data.type = 'meetup';
      }

      checkParameters(data, domain);
      setSocialLoginRequestPayload(data);
      sendFacebookLoginDataToBackend(data);
    },
  });

  const { appleLogin } = useAppleLogin({
    onSuccess(data) {
      checkParameters(data, domain);
      setSocialLoginRequestPayload(data);
      sendAppleLoginDataToBackend(data);
    },
  });

  useEffect(() => {
    const windowWidth = screen.width;

    const currentdomain = window.location.href;
    if (window.location.pathname === '/') {
      setCategory('homePage');
    } else if (
      /(\/pt\/criar)|(\/ru\/sozdayte)|(\/es\/crear)|(\/fr\/creer)|\/((zh-CN|zh-TW|id|my|jp|de|it|tr)\/)?(make\/)/.test(
        currentdomain,
      )
    ) {
      document.cookie = `${'source='}${window.location.host}${
        window.location.pathname
      }; domain=invideo.io; path=/`;
      setDomain('landingPage');
    } else if (currentdomain.includes('/pricing')) {
      setCategory('pricingPage');
    } else {
      setCategory('website');
    }

    const urlParams = new URLSearchParams(location.search);

    if (urlParams.has('redirect_url')) {
      setTool_redirect_url(
        `https://${urlParams.get('redirect_url')}.invideo.io`,
      );
    }

    if (
      currentdomain.includes('utm_source=youtube') &&
      currentdomain.includes('utm_medium=cpv')
    ) {
      setDomain('YOUTUBE');
    } else if (
      currentdomain.includes('utm_source=google') &&
      currentdomain.includes('utm_medium=cpc')
    ) {
      setDomain('SEM');
      setAuthState(prevState => ({
        ...prevState,
        keyword: urlParams.get('keyword'),
        matchtype: urlParams.get('matchtype'),
        creative: urlParams.get('creative'),
        placement: urlParams.get('placement'),
        device: urlParams.get('device'),
      }));
    } else if (
      currentdomain.includes('utm_source=gdn') &&
      currentdomain.includes('utm_medium=cpc')
    ) {
      setDomain('GDN');
      setAuthState(prevState => ({
        ...prevState,
        keyword: true,
        matchtype: true,
        creative: urlParams.get('creative'),
        placement: urlParams.get('placement'),
        device: urlParams.get('device'),
      }));
    } else if (currentdomain.includes('utm_source=facebook')) {
      setDomain('FACEBOOK');

      setAuthState(prevState => ({
        ...prevState,
        site_source_name: urlParams.get('site_source_name'),
        campaign_id: urlParams.get('campaign_id'),
        adset_id: urlParams.get('adset_id'),
        placement: urlParams.get('placement'),
        ad_id: urlParams.get('ad_id'),
        adset_name: urlParams.get('adset_name'),
        ad_name: urlParams.get('ad_name'),
        campaign_name: urlParams.get('campaign_name'),
      }));
    } else if (currentdomain.includes('utm_source=bing')) {
      setDomain('BING');
    }

    setIsMeetupPresent(currentdomain.indexOf('/meetup') !== -1);
  }, []);

  function initOAuthListener(url, payload) {
    return new Promise((resolve, reject) => {
      // This payload will be used for post redirection call
      // paylaod will be passed to the final 'google_login' API after receiving 'code' token from OAuth.
      const Payload = {
        Url: removeParams(),
        Pagetype: pageType(),
        button_position: window.atob(
          localStorage.getItem('Button Position') || '',
        ),
        device_id: window.deviceId,
        profileDeviceId: window.deviceId,
      };

      checkParameters(Payload, domain);

      url.searchParams.append(
        'analytics_payload',
        window.btoa(JSON.stringify(Payload)),
      );

      const windowFeatures =
        'menubar=yes,location=yes,resizable=yes,scrollbars=yes,width=600,height=650,left=100,top=100';

      oAuthWindow.current = window.open(
        url.toString(),
        'OAuthLogin',
        windowFeatures,
      );

      window.addEventListener('message', event => {
        if (!process.env.GATSBY_AUTH_API_URL.includes(event.origin)) {
          return;
        }
        clearInterval(stopOauthTimer);
        if (event.data) {
          const { data } = event;

          if (data && data['jwt_token']) {
            // this.postGoogleLoginHandler(data.response, data.data);

            localStorage.setItem('authToken', data['jwt_token']);
            AuthAPI.getCompleteUserDetails().then(res => {
              if (res.data) {
                localStorage.setItem('authToken', data['jwt_token']);
                resolve(res.data);
              } else {
                reject('Failed to fetch the data');
              }
            });
          }
        }
      });
      // Listen for message event from oAuth popup window
      stopOauthTimer = setInterval(() => {
        oAuthWindow.current.postMessage('Message', '*');
        if (oAuthWindow.current.closed) {
          console.log(`OAuth Window Closed`);
          clearInterval(stopOauthTimer);
        }
      }, 500);
    });
  }

  function openGoogleLogin() {
    return new Promise((resolve, reject) => {
      const url = new URL(
        process.env.GATSBY_AUTH_API_URL + '/api/oauth2/google-login',
      );

      initOAuthListener(url)
        .then(response => {
          setCookieData(response);
          analyticaDeInVideoV2(response, 'Google').then(() => {
            /*if (deviceType === 'desktop' && pageType() === 'Make Page') {
              dispatch(openQuestionModal({ tab: 'signup' }));
              dispatch(closeAuthModal());
            } else {
              redirectUserToTool(response);
            }*/
            window.location.reload();
          });
          resolve(true);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  function openFacebookLogin() {
    return new Promise((resolve, reject) => {
      const url = new URL(
        process.env.GATSBY_AUTH_API_URL + '/api/oauth2/facebook-login',
      );

      initOAuthListener(url)
        .then(response => {
          setCookieData(response);
          analyticaDeInVideoV2(response, 'Facebook').then(() => {
            /*if (deviceType === 'desktop' && pageType() === 'Make Page') {
              dispatch(openQuestionModal({ tab: 'signup' }));
              dispatch(closeAuthModal());
            } else {
              redirectUserToTool(response);
            }*/
            window.location.reload();
          });
          resolve(true);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  function sendGoogleLoginDataToBackend(data, one_tap) {
    AuthAPI.googleLogin(data, one_tap ? one_tap : '')
      .then(({ data: response }) => {
        if (typeof response === 'object') {
          console.log(response);
          const googledata = {
            identity: data.email,
            secret: data.password,
          };
          setUserObject(googledata);
          setCookieData(response);
          analyticaDeInVideoV2(response, 'Google').then(() => {
            if (deviceType === 'desktop' && pageType() === 'Make Page') {
              dispatch(openQuestionModal({ tab: 'signup' }));
              dispatch(closeAuthModal());
            } else {
              redirectUserToTool(response);
            }
          });
        } else {
          // setError(prevState => ({
          //   ...prevState,
          //   socialEmail: 'An account already exists with this Email',
          // }));
        }
      })
      .catch(error => {
        // setError(prevState => ({
        //   ...prevState,
        //   socialEmail: 'An account already exists with this Email',
        // }));
        console.log(error);
      })
      .finally(() => {
        // setIsSubmitting(false);
      });
  }

  function sendFacebookLoginDataToBackend(data) {
    AuthAPI.facebookLogin(data)
      .then(({ data: response }) => {
        if (typeof response === 'object') {
          const facebookdata = {
            identity: data.email,
            secret: data.password,
          };
          setUserObject(facebookdata);
          setCookieData(response);
          analyticaDeInVideoV2(response, 'Facebook').then(() => {
            if (deviceType === 'desktop' && pageType() === 'Make Page') {
              dispatch(openQuestionModal({ tab: 'signup' }));
              dispatch(closeAuthModal());
            } else {
              redirectUserToTool(response);
            }
          });
          // if (response && response.phone && response.phone.length > 0) {
          // } else {
          //   $('#authModal').modal('hide');
          //   getPhoneNumber();
          //   const phoneModal = document.getElementById('phoneNumberModal');
          //   const userInput = phoneModal.querySelector('#login_user_id');
          //   if (userInput) {
          //     userInput.value = response.id;
          //   }
          // }
        } else {
          // setError(prevState => ({
          //   ...prevState,
          //   socialEmail: 'Invalid Phone Number',
          // }));
          // displayE
        }
      })
      .catch(error => {
        // setError(prevState => ({
        //   ...prevState,
        //   socialEmail: 'An account already exists with this Email',
        // }));
      })
      .finally(() => {
        // setIsSubmitting(false);
      });
  }

  function sendAppleLoginDataToBackend(data) {
    AuthAPI.appleLogin(data)
      .then(({ data: response }) => {
        if (typeof response === 'object') {
          const appledata = {
            identity: data.email,
            secret: data.password,
          };
          setUserObject(appledata);
          analyticaDeInVideoV2(response, 'Apple').then(() => {
            redirectUserToTool(response);
          });
          setCookieData(response);
        }
      })
      .catch(error => {
        // setError(prevState => ({
        //   ...prevState,
        //   socialEmail: 'An account already exists with this Email',
        // }));
      })
      .finally(() => {
        // setIsSubmitting(false);
      });
  }

  // const setCookie = (name, value) => {
  //   document.cookie = `${name}=${value || ''}; path=/`;
  // };

  function setCookieData(response) {
    if (response.account > 99500 && response.account % 2 !== 0) {
      new_user_templates = true;
    }
    // const temp = JSON.parse(data);
    if (response.token) {
      localStorage.setItem('authToken', response.token);
    }
    localStorage.setItem('authExpires', response.token_expires);
    localStorage.setItem(
      'accountDetails',
      JSON.stringify(response.account_details),
    );

    localStorage.setItem(window.btoa('user'), JSON.stringify(response));
    const nextYear = new Date(new Date().getTime() + 86400 * 365 * 1000);
    if ('new_user' in response && response.new_user) {
      sessionStorage.setItem('new_user', response.new_user);

      setCookie({
        name: 'module-federation',
        value: 'new',
        path: '/',
        expires: nextYear,
      });
    }
    const userStateData = getCookieValue('user-state');
    if (!userStateData && isUserLoggedIn()) {
      setCookie({
        name: 'user-state',
        value: 'LoggedIn',
        path: '/',
        expires: nextYear,
      });
    }
  }

  async function redirectUserToTool(data, dimension = '16:9') {
    let url;
    let CTAlink = sessionStorage.getItem('redirectTo');
    let isTemplateCTAClicked = sessionStorage.getItem('isTemplateCTAClicked');
    let templateId = sessionStorage.getItem('templateId');
    let selectedDimension = sessionStorage.getItem('selectedDimension');
    let isHeaderCTAClicked = sessionStorage.getItem('isHeaderCTAClicked');

    if (isHeaderCTAClicked) {
      sessionStorage.removeItem('isHeaderCTAClicked');
      window.location.reload();
      return;
    }

    if (selectedDimension) {
      dimension = selectedDimension;
    }

    if (
      (deviceType === 'desktop' && pageType() === 'Make Page') ||
      (deviceType === 'desktop' && getCookieValue(btoa('no_login_exp')))
    ) {
      // url = `${window.location.origin}/editor?id=10456&dimension=${dimension}&workflow=story&searchTerm=&cacheRefresh=true&category=intro`;
      updateEditorAuthCookie();
      const editorHost = getEditorHost();
      const editorParams = globalStore.editorParams;

      url = `${editorHost}/editor?id=${
        templateId ? templateId : '10456'
      }&dimension=${dimension}&workflow=story&searchTerm=${
        editorParams?.searchTerm ? editorParams.searchTerm : ''
      }&cacheRefresh=true${
        !isTemplateCTAClicked
          ? editorParams?.tabType
            ? '&tabType=uploads'
            : ''
          : ''
      }${editorParams?.categoryTray ? '&category=intro' : ''}`;
    } else {
      url = CTAlink
        ? CTAlink
        : `${tool_redirect_url}/workflow/marketing-templates`;
    }
    console.log(`redirect`);
    goToTemplates = false;
    sessionStorage.removeItem('isTemplateCTAClicked');
    sessionStorage.removeItem('templateId');
    sessionStorage.removeItem('selectedDimension');
    window.open(url, '_self');
  }

  async function invideoSignIn(e) {
    e.preventDefault();

    console.log(`Login Called`);
    const data = {
      userid: loginValues.emailLogin,
      password: loginValues.passwordLogin,
      route: 'invideo',
      page_source: window.location.href,
      device_id: window.deviceId || '',
    };
    resetLoginErrors();

    const result = await executeRecaptcha();
    data['recaptcha_response'] = result;

    // setIsSubmitting(true);

    // if (formFields.passwordLogin.length < 6) {
    //   setError(prevState => ({
    //     ...prevState,
    //     passwordLogin: 'Minimum 6 characters for password',
    //   }));
    //   setIsSubmitting(false);
    //   return false; // stops the execution.
    // }

    checkParameters(data, domain);

    // error(error) {
    //   // displayError(JSON.parse(error.responseText).message, 'sign-in');
    //   // $('.error-message').css({ 'display': 'block' });
    //   // submitButton.html('Log In');
    //   // $(submitButton).removeClass('btn-shimmer');
    // },
    AuthAPI.emailLogin(data)
      .then(({ data: response }) => {
        if (typeof response === 'object') {
          setUserObject({
            identity: loginValues.emailLoginemail,
            secret: loginValues.passwordLogin,
          });
          setCookieData(response);
          analyticaDeInVideoV2(response, 'Email').then(() => {
            if (deviceType === 'desktop' && pageType() === 'Make Page') {
              const isHeaderCtaClicked =
                sessionStorage.getItem('isHeaderCTAClicked');
              if (isHeaderCtaClicked) {
                redirectUserToTool(response);
              } else {
                dispatch(openQuestionModal({ tab: 'signup' }));
                dispatch(closeAuthModal());
              }
            } else {
              redirectUserToTool(response);
            }
          });
          setSocialLoginRequestPayload(response);
        } else {
          // $('.error-message').css({ 'display': 'block' });
          // submitButton.html('Log In');
          // $(submitButton).removeClass('btn-shimmer');
        }
        // setIsSubmitting(false);
      })
      .catch(error => {
        if (error.response.status === 403) {
          // setError(prevState => ({
          //   ...prevState,
          //   login: 'Invalid Email/Password, Please try again',
          // }));
        }
        // setIsSubmitting(false);
      });
  }

  function googleOneTapSignIn(profileData) {
    const fullName = profileData.name;
    const id = profileData.sub;
    const password = profileData.sub;
    const email = profileData.email;
    const image = profileData.picture || '';
    const data = {
      full_name: fullName,
      image,
      email,
      password,
      uid: id,
      brand_name: 'Your Company Name',
      route: 'google one tap',
      referrer: 'website',
      page_source: window.location.href,
      device_id: window.deviceId || '',
    };
    if (isMeetupPresent) {
      data.type = 'meetup';
    }

    checkParameters(data, domain);
    setSocialLoginRequestPayload(data);
    sendGoogleLoginDataToBackend(data, 'one_tap');
  }

  function enableOneTapSignIn() {
    /**
     * Google One Tag Login/Signup was setup as experiment to increase signup
     * Not used any more.
     */

    if (
      !document.querySelector(
        `script[src="https://accounts.google.com/gsi/client"]`,
      )
    ) {
      loadScript({
        d: document,
        id: 'one_tap_google_auth',
        jsSrc: 'https://accounts.google.com/gsi/client',
        cb: () => {
          const clientId = process.env.GATSBY_GOOGLE_CLIENT_ID;
          window.google.accounts.id.initialize({
            client_id: clientId,
            callback: response => {
              googleOneTapSignIn(jwt_decode(response.credential));
            },
          });
          window.google.accounts.id.prompt();
        },
      });
    }
  }

  function analyticaDeInVideoV2(response, route) {
    let event_action;
    if (response.new_user) {
      event_action = `${route} SignUp`;
    } else {
      event_action = `${route} SignIn`;
    }
    try {
      if ('fbq' in window) {
        if (response.new_user) {
          window.fbq('track', 'CompleteRegistration', {
            value: 0.0,
            currency: 'USD',
            referrer: domain,
            category,
          });
        } else {
          window.fbq('trackCustom', 'Logged In', {
            referrer: domain,
            category,
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
    return new Promise((resolve, reject) => {
      window.dataLayer.push({ user_id: response.id });
      window.dataLayer.push({
        event: 'formSubmitted',
        userAction: event_action,
        referrer: domain,
        // prettier-ignore
        ...({ email_archetype: response.email_archetype }),
        category,
        eventCallback: function () {
          resolve();
        },
        eventTimeout: 2000,
      });
      if (!window['google_tag_manager']) {
        resolve();
      }
    });
  }

  async function handleGuestSignup(dimension = '16:9') {
    setIsGuestSignupSubmitting(true);
    const signupData = {
      route: 'invideo',
      page_source: window.location.href,
      device_id: window.deviceId || '',
    };
    const result = await executeRecaptcha();
    signupData['recaptcha_response'] = result;

    checkParameters(signupData, domain);

    AuthAPI.guestEmailSignup(signupData)
      .then(({ data: response }) => {
        if (typeof response === 'object') {
          setCookieData(response);
          setIsGuestSignupSubmitting(false);
          redirectUserToTool(response, dimension);
        } else {
          setSignupError('An account already exists with this Email');
        }
      })
      .catch(error => {
        setIsGuestSignupSubmitting(false);
        setGuestSignupError('An error occurred while processing your request!');
      })
      .finally(() => {
        setIsGuestSignupSubmitting(false);
      });
  }

  function isGuestUser() {
    const user = localStorage.getItem(window.btoa('user'));
    let isGuestUser = false;
    if (user) {
      const userObj = JSON.parse(user);
      isGuestUser = userObj.guest_user;
    }
    return isGuestUser;
  }

  function isUserLoggedIn() {
    return (
      localStorage.getItem('authToken') != null &&
      localStorage.getItem('authToken') !== undefined &&
      localStorage.getItem('authToken').trim() !== ''
    );
  }

  return {
    googleSignIn,
    facebookLogin,
    enableOneTapSignIn,
    appleLogin,
    invideoSignIn,
    // invideoSignUp,
    // forgotPassowrd,
    // formFields,
    // createChangeHandler,
    // blurHandler,
    loginErrors,
    loginValues,
    onLoginChange,
    onLoginBlur,
    forgotPasswordSuccess,
    isLoginSubmitting,
    isLoginValid,
    loginFormError,
    handleLoginSubmit,
    signupErrors,
    handleSingup,
    isSignupSumitting,
    onChangeSignup,
    signupValues,
    isValidSignup,
    signupError,
    onBlurSignup,
    redirectUserToTool,
    countryCodes,
    selectedCountry,
    handleOnChangeCountry,
    forgotFormError,
    errorsForgotPassword,
    handleSubmitForgotPassword,
    isSubmittingForgot,
    onChangeForgotPassword,
    valuesForgotPassowrd,
    isValidForgotPassword,
    onBlurForgotPassword,
    setSelectedCountry,
    handleGuestSignup,
    guestSignupError,
    isGuestSignupSubmitting,
    isGuestUser,
    openGoogleLogin,
    openFacebookLogin,
    isUserLoggedIn,
  };
}

export default useAuth;
